export const SKY_DRAGON_ATTACK_RUN = Object.freeze({ duration: 1.8, lateral: 0.35 });

/** Sample a close-face shoulder strafe in metres and active seconds. The
 * negative lateral excursion stays outside the face centre and returns to the
 * already validated acquisition point. Zero endpoint speed/acceleration avoid
 * jolting the physical eye. Invalid/expired ages return the original position.
 * This does not grant fire, vulnerability, immunity or extend an opening. */
export function skyDragonAttackRunPosition(origin, age) {
  const t = Number.isFinite(age)
    ? Math.max(0, Math.min(1, age / SKY_DRAGON_ATTACK_RUN.duration))
    : 0;
  const progress = t * t * t * (10 - 15 * t + 6 * t * t);
  const offset = -SKY_DRAGON_ATTACK_RUN.lateral * Math.sin(Math.PI * progress) ** 2;
  return { x: origin.x + offset, y: origin.y, z: origin.z };
}

/** Advance one authored live route per actual settled aperture. Initial dwell
 * stays still; closed/charging/transit phases cancel the route immediately.
 * The guardian owner must call after anatomy/vulnerability refresh. */
export function stepSkyDragonAttackRun(state, dt) {
  const boss = state.boss;
  if (
    !boss ||
    boss.artVariant !== 'first-dragon' ||
    !boss.aimWindow ||
    boss.aimPreparing ||
    state.traversal ||
    boss.breath?.active
  ) {
    if (boss) boss.attackRun = null;
    return;
  }
  if ((boss.aimDwell ?? 0) > 0 || !Number.isFinite(dt) || dt <= 0) return;
  if (!boss.attackRun) {
    boss.attackRun = {
      active: true,
      age: 0,
      origin: { x: state.x, y: state.y, z: state.pilotZ ?? 1 },
    };
  }
  const run = boss.attackRun;
  if (!run.active) return;
  run.age = Math.min(SKY_DRAGON_ATTACK_RUN.duration, run.age + dt);
  const position = skyDragonAttackRunPosition(run.origin, run.age);
  state.x = position.x;
  state.y = position.y;
  state.pilotZ = position.z;
  if (run.age >= SKY_DRAGON_ATTACK_RUN.duration) run.active = false;
}
